import React from "react";
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Syllabus</h1>
                <p>Home &gt; Syllabus &gt; Skill Development</p>
            </div>
        </div>
    );
};

export default Hero;
